import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Stack, Chip, Typography, Divider, Box
} from '@mui/material';

export default function EventViewDialog({ open, onClose, event, onEdit }) {
  if (!event) return null;
  const dt = (ms) => (ms ? new Date(ms).toLocaleString() : '—');
  const isPeer = !!event?.peerReview?.enabled;
  const qs = isPeer ? (event?.peerReview?.schema || []) : (event?.questionnaire?.questions || []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Event details</DialogTitle>
      <DialogContent dividers sx={{ textAlign: 'left' }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="h6" sx={{ mb: .5 }}>{event.title || '—'}</Typography>
            <Typography variant="body2" color="text.secondary">{event.description || '—'}</Typography>
          </Box>

          <Stack direction="row" spacing={1} alignItems="center">
            <Chip size="small" label={isPeer ? 'PEER REVIEW' : 'STANDARD'} />
            <Chip size="small" color={event.status === 'PUBLISHED' ? 'success' : 'default'} label={event.status || 'DRAFT'} />
          </Stack>

          <Divider />

          <Stack spacing={0.5}>
            <Typography variant="subtitle2">Schedule</Typography>
            <Typography variant="body2">Start: {dt(event?.dates?.start)}</Typography>
            <Typography variant="body2">End: {dt(event?.dates?.end)}</Typography>
            <Typography variant="body2">Entry allowed from: {dt(event?.dates?.entryAllowedAt)}</Typography>
            <Typography variant="body2">Duration: {event?.dates?.durationMinutes || 30} minutes</Typography>
          </Stack>

          {!!event?.instructions && (
            <>
              <Divider />
              <Stack spacing={0.5}>
                <Typography variant="subtitle2">Instructions</Typography>
                <Typography variant="body2" whiteSpace="pre-wrap">{event.instructions}</Typography>
              </Stack>
            </>
          )}

          <Divider />

          <Stack spacing={0.5}>
            <Typography variant="subtitle2">{isPeer ? 'Questions (peer schema)' : 'Questions'}</Typography>
            {qs.map((q, i) => (
              <Box key={q.id || i} sx={{ p: 1, bgcolor: 'action.hover', borderRadius: 1, mb: .5 }}>
                <Typography variant="body2"><b>Q{i + 1}.</b> {q.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Type: {q.type}{q.type === 'MCQ' && q?.options ? ` — options: ${q.options.filter(Boolean).join(', ')}` : ''} · Weight: {q.weight ?? 0} · {q.required ? 'Required' : 'Optional'}
                </Typography>
              </Box>
            ))}
          </Stack>

          <Divider />

          <Stack spacing={0.5}>
            <Typography variant="subtitle2">Audience</Typography>
            {event?.audience?.all
              ? <Typography variant="body2">All employees</Typography>
              : <Typography variant="body2">{Array.isArray(event?.audience?.selected) ? `${event.audience.selected.length} selected` : '—'}</Typography>}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={onEdit}>Edit</Button>
      </DialogActions>
    </Dialog>
  );
}
